module.exports = __webpack_public_path__ + "img/CARD_ON_DELIVERY.83cdc23a.png";